import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ListItem(props) {
  const {
    icon,
    label,
    sublabel,
    description,
    size,
    selected,
    onClick,
  } = props;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick(event);
    }
  };

  return (
    <div
      className={classNames('pgn__listitem-wrapper')}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-pressed={selected}
    >
      <div className={classNames('pgn__listitem-body', `listitem-${size}`, { 'listitem-selected': selected })}>
        {icon && (
        <div className="listitem-icon">
          {icon}
        </div>
        )}
        {size !== 'lg' && (
          <div className="listitem-main">
            <div className="listitem-label">
              {label}
            </div>
            <div className="listitem-sublabel">
              {sublabel}
            </div>
          </div>
        )}
        {size === 'lg' && (
          <div className="listitem-main">
            <div className="listitem-label">
              {label}
            </div>
            <div className="listitem-description">
              {description}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

ListItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node,
  sublabel: PropTypes.node,
  description: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

ListItem.defaultProps = {
  icon: null,
  label: null,
  sublabel: null,
  description: null,
  size: 'sm',
  selected: false,
  onClick: () => { },
};

export default ListItem;
